import { addGroup } from './processors/addGroup'
import { addViewPath } from './processors/addViewPath'
import { registerProcessor } from './useCommandStore'

registerProcessor(addGroup)
registerProcessor(addViewPath)
